import React, { useState } from 'react'
import { Container, Row, Col } from 'reactstrap'
import { useNavigate } from 'react-router-dom'
import Header from '../components/Header'
import UsersPasswordCard from '../components/users/UsersPasswordCard'
import apiLoginService from '../services/apiLoginService'
import '../styles/FormView.css'

function UsersPasswordView() {
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    newPassword: '',
    confirmPassword: '',
  })
  const [errors, setErrors] = useState({})
  const [submitted, setSubmitted] = useState(false)
  const [isSaving, setIsSaving] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [successMessage, setSuccessMessage] = useState('')

  const handleInputChange = (event) => {
    const { name, value } = event.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))

    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: '',
      }))
    }
  }

    function parseJwt(token) {
  try {
    const base64Payload = token.split('.')[1] 
    const payload = atob(base64Payload) 
    return JSON.parse(payload) 
  } catch (e) {
    console.error('Error al decodificar Token', e)
    return null
  }
}
    

  const validateForm = () => {
    const newErrors = {}
    if (!formData.newPassword.trim()) {
      newErrors.newPassword = 'La nueva contraseña es requerida'
    }
     else if (formData.newPassword.length < 6) {
    newErrors.newPassword = 'La contraseña debe tener al menos 6 caracteres'
    }

    if (!formData.confirmPassword.trim()) {
      newErrors.confirmPassword = 'Debes confirmar la nueva contraseña'
    } else if (formData.newPassword !== formData.confirmPassword) {
      newErrors.confirmPassword = 'Las contraseñas no coinciden'
    }

    return newErrors
  }

  const handleSubmit = async (event) => {
    event.preventDefault()
    setSubmitted(true)
    setErrorMessage('')
    setSuccessMessage('')

    const newErrors = validateForm()
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors)
      return
    }
     const token = sessionStorage.getItem('token')
     const payload = parseJwt(token)
     const userId = payload?.userId

    setIsSaving(true)
    try {
      await apiLoginService.updateUser(userId, { password: formData.newPassword })
      setSuccessMessage('Contraseña actualizada correctamente.')
      setTimeout(() => navigate('/'), 600)
    } catch (error) {
      const message =
        error?.body?.message || 'No se pudo actualizar la contraseña.'
      setErrorMessage(message)
    } finally {
      setIsSaving(false)
    }
  }

  return (
    <>
      <Header />
      <Container fluid className="form-container">
        <Container>
          <div className="form-header">
            <h1>Cambiar contraseña</h1>
          </div>
          <Row className="justify-content-center">
            <Col xs={12} md={8} lg={6}>
              <UsersPasswordCard
                formData={formData}
                errors={errors}
                submitted={submitted}
                isSaving={isSaving}
                errorMessage={errorMessage}
                successMessage={successMessage}
                onInputChange={handleInputChange}
                onSubmit={handleSubmit}
              />
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  )
}

export default UsersPasswordView
